import { addCents, cents, quantiseUp } from "./money.js";
/**
 * Delivery pricing. Distance-based, the way Grab does it, measured from the
 * Chbar Ampov office where the trucks load.
 *
 * The rate card is set against what Phnom Penh actually pays. foodpanda fees
 * observed on foodpanda.com.kh, 13 Sep 2026: $0.64, $0.74, $0.75, $0.89 and
 * $1.00 for ordinary city deliveries, rising to $3.09 for a distant vendor.
 * Grab KH states its fee is calculated on pick-up to drop-off distance.
 * A customer comparing us against those apps must not find us dearer for the
 * same trip, so a short hop lands at $0.75 and the far edge of town at $2.25.
 *
 * Kilometres are road distance from DEPOT to the customer's pin, routed on
 * the server. The rate card knows nothing about where the pin is.
 */
/**
 * Where every delivery starts: the Moo Moo Farms office and warehouse in
 * Chbar Ampov, given by James on 13 Sep 2026 as the Google Maps place
 * `0x310957cd69fecf2f:0xfcc9af8dfddab645`. Any routing call measures from
 * here. Longitude first in `lngLat` because OSRM, Mapbox and GeoJSON all
 * want it that way and mixing the order is the classic mistake.
 */
export const DEPOT = {
    nameEn: "Moo Moo Farms Office",
    nameKh: "ការិយាល័យ Moo Moo Farms",
    lat: 11.5256875,
    lng: 104.9455625,
    lngLat: [104.9455625, 11.5256875],
    mapsUrl: "https://maps.google.com/?cid=18215283192260900421",
};
export const FEE_BASE = cents(40);
export const FEE_PER_KM = cents(10);
export const FEE_MIN = cents(50); /* a quarter multiple, so cash still works */
/** Fees are shown to the nearest 25 cents so drivers can take cash. */
export const FEE_STEP = 25;
/** The rate card. Exported separately so it can be unit-tested on distance alone. */
export function feeForKm(km) {
    if (!Number.isFinite(km) || km < 0)
        throw new RangeError(`feeForKm: bad km: ${km}`);
    const raw = addCents(FEE_BASE, cents(Math.round(FEE_PER_KM * km)));
    const quantised = quantiseUp(raw, FEE_STEP);
    return quantised < FEE_MIN ? FEE_MIN : quantised;
}
/**
 * Wholesale pays nothing: those orders ride the route the trucks already
 * drive, so charging for distance would be inventing a cost. Retail without
 * a pin yet pays nothing either, so the cart can show a subtotal before the
 * customer reaches the map; the server never prices without a pin.
 */
export function deliveryFeeForKm(input) {
    if (input.channel === "wholesale")
        return cents(0);
    if (input.subtotal <= 0)
        return cents(0);
    if (input.km === undefined)
        return cents(0);
    return feeForKm(input.km);
}
//# sourceMappingURL=delivery.js.map